/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    EmploymentStatus: {
        id: 'quoteandbind.common.EmploymentStatus',
        defaultMessage: 'Please select {possessivePronoun} employment status'
    },
    OtherEmploymentStatus: {
        id: 'quoteandbind.common.OtherEmploymentStatus',
        defaultMessage: 'Please select an alternative employment status'
    },
    ApproxRetirement: {
        id: 'quoteandbind.common.ApproxRetirement',
        defaultMessage: 'Approximately when are {possessivePronoun} looking to retire?'
    },
    ApproxRetirementSubLabel: {
        id: 'quoteandbind.common.ApproxRetirementSubLabel',
        defaultMessage: 'If you are not sure, please give an approximate date.'
    },
    EmploymentStatusSubLabel: {
        id: 'quoteandbind.common.EmploymentStatusSubLabel',
        defaultMessage: 'This will be {possessivePronoun} main employment status. If, for example, {pronoun} are retired but also do part-time or voluntary work, please select \'Retired\'.'
    },
    FakeEmploymentStatusErrorMessage: {
        id: 'quoteandbind.common.FakeEmploymentStatusErrorMessage',
        defaultMessage: 'Please select an employment status'
    },
    PartTimeOccupationLabel: {
        id: 'quoteandbind.common.PartTimeOccupationLabel',
        defaultMessage: 'Are {pronoun} currently doing any part-time or voluntary work?'
    },
    partTimeOccupationTypeSelect: {
        id: 'quoteandbind.common.partTimeOccupationTypeSelect',
        defaultMessage: 'What is {possessivePronoun} part-time or voluntary occupation?'
    },
    studentTypeLabel: {
        id: 'quoteandbind.common.studentTypeLabel',
        defaultMessage: 'What type of student are {pronoun}?'
    },
    OccupationLookupLabel: {
        id: 'quoteandbind.common.OccupationLookupLabel',
        defaultMessage: 'What is {possessivePronoun} main occupation?'
    },
    PartTimeOccupationLookupLabel: {
        id: 'quoteandbind.common.PartTimeOccupationLookupLabel',
        defaultMessage: 'Please type {possessivePronoun} part-time or voluntary occupation: '
    },
    OccupationLookupSubLabel: {
        id: 'quoteandbind.common.OccupationLookupSubLabel',
        defaultMessage: 'If {possessivePronoun} occupation is not listed, simply search for a more generic term and choose the closest occupation. For example: teacher, civil servant, engineer, office worker.'
    },
    OccupationLookupPlaceHolder: {
        id: 'quoteandbind.common.OccupationLookupPlaceHolder',
        defaultMessage: 'Type the first 3 letters…'
    },
    OccupationLookupTopDropdownText: {
        id: 'quoteandbind.common.OccupationLookupTopDropdownText',
        defaultMessage: 'please choose from list below'
    },
    OccupationLookupBottomDropdownText: {
        id: 'quoteandbind.common.OccupationLookupBottomDropdownText',
        defaultMessage: 'if an exact job title isn’t on the list, please choose the closest match'
    },
    OccupationLookupResultNotFoundMessage: {
        id: 'quoteandbind.common.OccupationLookupResultNotFoundMessage',
        defaultMessage: 'Sorry – we haven\'t been able to find a matching job title. Please try searching another, perhaps less specific, term and select the closest match from the list.'
    },
    OccupationLookupErrorMessage: {
        id: 'quoteandbind.common.OccupationLookupErrorMessage',
        defaultMessage: 'Sorry - We haven\'t been able to find a matching job title. Please try another, perhaps a less specific term. Alternatively, please type 3 or more letters and a list will appear for you to pick the closest match.'
    },
    BusinessTypeLabel: {
        id: 'quoteandbind.common.BusinessTypeLabel',
        defaultMessage: 'Type of business'
    },
    BusinessTypeSubLabel: {
        id: 'quoteandbind.common.BusinessTypeSubLabel',
        defaultMessage: 'For example childminding, hairdressing or education'
    },
    BusinessTypePlaceHolder: {
        id: 'quoteandbind.common.BusinessTypePlaceHolder',
        defaultMessage: 'Please start typing the first 3 letters'
    },
    BusinessTypeTopDropdownText: {
        id: 'quoteandbind.common.BusinessTypeTopDropdownText',
        defaultMessage: 'please choose from list below'
    },
    BusinessTypeBottomDropdownText: {
        id: 'quoteandbind.common.BusinessTypeBottomDropdownText',
        defaultMessage: 'if you cannot find your exact business type, please look for the closest match'
    },
    BusinessTypeResultNotFoundMessage: {
        id: 'quoteandbind.common.BusinessLookupResultNotFoundMessage',
        defaultMessage: 'Sorry - we haven\'t been able to find a matching business type. Please try searching on another, perhaps less specific term'
    },
    BusinessTypeErrorMessage: {
        id: 'quoteandbind.common.BusinessTypeErrorMessage',
        defaultMessage: 'Business type not found'
    }
});
